export const projectColors = {
  bluePrimary: "#8ac2d9",
  blueSecondary: "#4a94ab",
  orangePrimary: "#f25938",
  orangeSecondary: "#f25938",
};

const colors = {
  light: "#339fa7",
  main: "#008792",
  dark: "#016871",
};

const styleVariables = {
  navbarHeight: "4rem",
  inputFieldHeight: "4.44rem",
  baseColor: colors.main,
  secondaryColor: projectColors.orangePrimary,
  lightBaseColor: colors.light,
  darkBaseColor: colors.dark,
  basicRadius: "6px",
  borderColor: "#ced5db",
  // lightBaseColor: tinycolor("#0f2147").setAlpha(0.5).toRgbString(),
  background: {
    light: "#e8e8e8",
    dark: "#0f2147",
  },
  button: {
    default: "#4993aa",
    hovered: "#387082",
  },
  fontFamily: "'Montserrat', sans-serif",
  shadows: {
    basicShadow: "0px 0px 5px 1px rgba(0,0,0,0.15)",
  },
  media: {
    smallscreen: "screen and (min-width: 1280px)",
    bigscreen: "screen and (min-width: 1920px)",
    // retina:
    //   "screen and (-webkit-min-device-pixel-ratio: 2) and (max-resolution: 192dpi) and (orientation: landscape)",
  },
};

export const buttonDefaultStyles = {
  // fontFamily: "Helvetica",
  fontWeight: 700,
  color: "white",
  background: "#e35f52",
  "&:hover, &:focus": {
    background: "#e87c73",
  },
};

export function sidebarButtonDefaultStyles(props) {
  return {
    display: "grid",
    gridTemplateColumns: "1fr max-content",
    justifyItems: "baseline",
    alignItems: "center",
    // fontFamily: "'Roboto Slab', serif",
    fontFamily: "'fantasy', sans-serif",
    fontSize: "small",
    fontWeight: 700,
    color: "white",
    background: colors.dark,

    border: props?.isSelected ? "1px solid white" : `1px solid ${colors.dark}`,

    padding: ".4rem .5rem",
    cursor: "pointer",
    borderRadius: ".5rem",
    "&:hover, &:focus": {
      background: "grey",
      border: props?.isSelected ? "1px solid white" : `1px solid grey`,
    },
    "&:focus": {
      border: props?.isSelected
        ? "1px solid white"
        : `1px solid ${colors.dark}`,
      outline: "none",
    },
  };
}

export default styleVariables;
